import React from "react";
import { FileText, Clock, MapPin } from "lucide-react";
import { PageHero } from "./PageHero";
import { QuoteForm } from "./QuoteForm";

const benefits = [
  { icon: <FileText className="h-6 w-6" />, title: "Detailed Estimates", desc: "Clear quotes with no hidden costs." },
  { icon: <Clock className="h-6 w-6" />, title: "Quick Response", desc: "We'll reach out for more information fast." },
  { icon: <MapPin className="h-6 w-6" />, title: "DMV + Nationwide", desc: "Local expertise with national reach." },
];

export const QuotePage = () => {
  return (
    <div data-testid="quote-page">
      <PageHero
        kicker="Free Estimate"
        title="Get Your Free"
        highlight="Project Quote"
        subtitle="Ready to start your demolition or site work project? Fill out the form below and someone will reach out for more information. Serving the DMV area and nationwide."
      >
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-px bg-border border border-border max-w-4xl">
          {benefits.map((b) => (
            <div key={b.title} className="bg-card p-6">
              <div className="w-11 h-11 flex items-center justify-center border border-primary/30 bg-primary/10 text-primary mb-3">{b.icon}</div>
              <h3 className="font-display text-lg font-bold uppercase tracking-tight text-white">{b.title}</h3>
              <p className="text-sm text-gray-400 mt-1">{b.desc}</p>
            </div>
          ))}
        </div>
      </PageHero>

      <QuoteForm />
    </div>
  );
};
